const ADD_SOURCE = 'ADD_SOURCE';
const ADD_MULTIPLE_SOURCES = 'DECREMADD_MULTIPLE_SOURCESENT_ACTIVE_STEP';
const REMOVE_SOURCE = 'REMOVE_SOURCE';
const SET_SELECTED_PIPELINE_GROUP = 'SET_SELECTED_PIPELINE_GROUP';
const SET_PIPELINE_GROUPS = 'SET_PIPELINE_GROUPS';
const SET_DISCOVERY_ID = 'SET_DISCOVERY_ID';
const SET_DATA_SAMPLE_SESSION_ID = 'SET_DATA_SAMPLE_SESSION_ID';

export default {
  ADD_SOURCE,
  ADD_MULTIPLE_SOURCES,
  REMOVE_SOURCE,
  SET_SELECTED_PIPELINE_GROUP,
  SET_PIPELINE_GROUPS,
  SET_DISCOVERY_ID,
  SET_DATA_SAMPLE_SESSION_ID
};
